<template>
  <div>
    <back-btn />

    <v-row>
      <v-col lg="10" offset-lg="1">
        <visit-data-view></visit-data-view>
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="10" offset-lg="1">
       <v-card>
        <v-card-title>DOTS Drugs</v-card-title> 
          <v-card-text>
           <span v-for="drug in dotsDrugs" :key="drug.value">
              <strong> {{drug.text}}, </strong>
           </span>
          </v-card-text>
       </v-card>
      </v-col>
    </v-row>
    <end-dots-form></end-dots-form>
  </div>
</template>

<script>
import VisitDataView from "@/components/dots/VisitDataView.vue";
import EndDotsForm from "@/components/dots/UseApp/EndDotsForm.vue";
import BackBtn from "@/components/navigation/BackBtn.vue";
import { dots_drugs } from '../../services/options'
import { mapState } from "vuex";

export default {
  components: {
    "visit-data-view": VisitDataView,
    BackBtn,
    EndDotsForm,
  },
  data() {
    return {
      dots_drugs
    };
  },
  computed: {
    ...mapState("DotsPatient", ["data"]),
    dotsDrugs() {
      let drugs = []
      if(typeof this.data.dots_drugs === 'string')
      drugs = JSON.parse(this.data.dots_drugs)
      else drugs = this.data.dots_drugs
      const drugList = []
      if(drugs){
        for (const d of drugs) {
          const drug = this.dots_drugs.find((v) => v.value === d)
          if(drug) drugList.push(drug)
        }
      }
      return drugList
    }
  },
  created() {
    this.$store.dispatch("Loading/changeLocalLoading");
    this.$store
      .dispatch("DotsPatient/getEach", {
        column: "id",
        value: this.$route.params.id,
      })
      .then((isPass) => {
        if (isPass) this.$store.dispatch("Loading/changeLocalLoading");
      });
  },
};
</script>

<style></style>
